import { useQuery } from '@tanstack/react-query';
import { TimeZoneApi } from '../apis/time-zone-api';
import CloseableErrorMessage from '../components/CloseableErrorMessage';

export const TimeZoneQueries = {
  useTimeZones: () =>
    useQuery({
      queryKey: ['timeZones'],
      queryFn: async () => await TimeZoneApi.getTimeZones(),
      onError: () => CloseableErrorMessage('Error getting time zone information.'),
    }),
};
